import React, { useEffect } from "react";
import ChatGptData from "../components/ChatGptData";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";

const EnterpriseChat = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage chatGptDataPage">
        <ChatGptData />
      </div>
    </div>
  );
};

export default EnterpriseChat;
